import { isOnlineOnlyRestricted } from "@faire/retailer-visitor-shared/lib/brandRestrictionUtils";
import { getIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { IBrand } from "@faire/web-api--source/indigofair/data/IBrand";

export const canAddToCart = (
  brand?: Pick<IBrand, "forbids_online_only_retailers">
): boolean => {
  return (
    !!RetailerStore.get().retailer &&
    !getIsBrandPreview() &&
    !isOnlineOnlyRestricted(brand)
  );
};
